import { setTheme, setRecentSearches } from "./localstorage";

// Action to enable/disable to loading indicator
export function setLoading(isLoading) {
  return isLoading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" };
}

export function setToogleTheme(flag, dontUpdate = false) {
  if (!dontUpdate) {
    setTheme(flag ? "dark" : "white"); // Update theme in local storage
  }

  return {
    type: "TOGGLE_THEME",
    payload: flag,
  };
}

export function setRecentSearch(list, dontUpdate = false) {
  if (!dontUpdate) {
    setRecentSearches(list); // Update in local storage
  }

  return {
    type: "RECENT_SEARCH",
    payload: list,
  };
}

export const setWruData = (payload, storyId) => {
  return {
    type: "STORY_WRU_DATA",
    payload,
    storyId,
  };
};

export const setMember = (member) => {
  return {
    type: "QT-MEMBER_UPDATED",
    member,
  };
};

export const setLogoutState = () => {
  return {
    type: "SET_LOGOUT_STATE",
    payload: true,
  };
};

export const setUserPlans = (plans) => {
  return {
    type: "SET_USER_PLANS",
    plans,
  };
};

export const setSectionId = (id) => {
  return {
    type: "SECTION_ID",
    payload: id,
  };
};
